const allowedTag = ['p', 'br'];
const attrMapping = [['class', 'className']];
export const HTMLComponentBuilder = (tag, attr) => {
    if (allowedTag.includes(tag)) {
        const props = {};
        attrMapping.forEach(([prev, next]) => {
            const old = attr[prev];
            if (old) {
                props[next] = old;
            }
        });
        return {
            constructor: tag,
            props,
        };
    }
    return {
        constructor: () => null,
        props: {},
    };
};
